import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { getFile } from "../../../../utils/getFile";
import config from "../../../../config";
import * as yup from "yup";
import User from "../../../../assets/img/icons/user1.png";
import { useParams } from "react-router-dom";
import { decrypt } from "../../../../utils/crypto";
import api from "../../../../api/axios";
import { formatDate3 } from "./../../../../validation";
import {
  formatCustomDate2,
  formatDateInTimezone,
} from "../../../../utils/formatDateInTimezone";
import { companyID } from "../../../../auth";
import {
  applyResignation,
  getEmployeesResignations,
  resignationApproval,
} from "../../../../services/ResignationServices";

// Yup schema for validation
const feedbackSchema = yup.object().shape({
  reviewer_comment: yup.string().required("*Reviewer comment is required"),
  review_status: yup.string().required("*Status is required"),
});

const PIPDetails = () => {
  const { t } = useTranslation();
  const [profileImage, setProfileImage] = useState({});
  const [reviewCycles, setReviewCycles] = useState([]);
  const [errors, setErrors] = useState({});
  const { employee_id } = useParams();
  const [pipDetails, setPipDetails] = useState({});

  const getPipData = async () => {
    try {
      const decryptedId = await decrypt(employee_id);
      const response = await api.get(`api/pip-detail/${decryptedId}`);
      setPipDetails(response?.data?.data || {});
    } catch (error) {
      console.error("Error fetching PIP data:", error);
    }
  };

  useEffect(() => {
    getPipData();
  }, []);

  useEffect(() => {
    const fetchImage = async () => {
      let image = null;
      if (pipDetails.photo) {
        try {
          const imageUrl = await getFile(
            `${config.IMAGE_URL}${pipDetails.photo}`
          );
          if (imageUrl) {
            image = imageUrl;
          }
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      }
      setProfileImage(image || User); // Fallback to default User image
    };

    fetchImage();

    // Update review cycles when pipDetails changes
    if (pipDetails?.review_cycles) {
      const updatedCycles = pipDetails.review_cycles.map((cycle) => ({
        ...cycle,
        editMode: cycle.feedbacks?.length === 0 ? true : false,
      }));
      setReviewCycles(updatedCycles);
    } else {
      setReviewCycles([]); // Ensure reviewCycles is an empty array if no data
    }
  }, [pipDetails]); // Add pipDetails as a dependency

  const today = new Date();

  const handleSaveFeedback = async (id) => {
    const cycle = reviewCycles.find((c) => c.id === id);
    const reviewed_by = localStorage.getItem("employeeID");
    const decryptedId = await decrypt(employee_id);
    const company_id = companyID();
    console.log("cycle", cycle);

    try {
      // Validate with Yup
      await feedbackSchema.validate(
        {
          reviewer_comment: cycle.reviewer_comment,
          review_status: cycle.review_status,
        },
        { abortEarly: false }
      );

      // Clear errors if validation passes
      setErrors((prev) => ({ ...prev, [id]: {} }));

      const data = {
        cycle,
        pip_review_id: id,
        reviewed_by: reviewed_by,
        reviewer_comment: cycle.reviewer_comment,
        review_status: cycle.review_status,
        employee_id: decryptedId,
        company_id: companyID(),
        pip_record_id: pipDetails?.pip_record_id,
        cycle_length: pipDetails?.review_cycles.length,
        pip_end_date: pipDetails?.end_date,
        pip_start_date: pipDetails?.start_date,
        employee_department_notice_config_id : pipDetails?.employee_department_notice_config_id,
        terminate_after_pip :pipDetails?.terminate_after_pip,
      };

      const feedback_response = await api.post(`api/pip-feedback`, data);
      console.log("response2345", feedback_response);
      console.log("response23", feedback_response);
      if (feedback_response?.data?.termination_data?.length > 0) {
        const response = await applyResignation(
          feedback_response?.data?.termination_data[0]
        );
        const filterKey = "approved_by";
        const filterValue = employee_id;
        const employee_resignation_Detail = await getEmployeesResignations(
          company_id,
          filterKey,
          filterValue
        );
      }

      getPipData();
      setReviewCycles((prev) =>
        prev.map((c) =>
          c.id === id
            ? {
                ...c,
                editMode: false,
              }
            : c
        )
      );
    } catch (err) {
      if (err.inner) {
        const cycleErrors = {};
        err.inner.forEach((e) => {
          cycleErrors[e.path] = e.message;
        });
        setErrors((prev) => ({ ...prev, [id]: cycleErrors }));
      }
    }
  };

  const handleReEdit = (id) => {
    setReviewCycles((prev) =>
      prev.map((cycle) =>
        cycle.id === id
          ? {
              ...cycle,
              editMode: true,
              reviewer_comment: cycle.feedbacks[0]?.reviewer_comment || "",
              review_status: cycle.feedbacks[0]?.review_status || "",
            }
          : cycle
      )
    );
  };

  const handleChange = (id, field, value) => {
    setReviewCycles((prev) =>
      prev.map((cycle) =>
        cycle.id === id ? { ...cycle, [field]: value } : cycle
      )
    );
  };

  return (
    <div>
      <div className="page-wrapper" style={{ position: "relative" }}>
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle={t("PIP Detail")}
            title={t("Dashboard")}
            subtitle={t("PIP Detail")}
            action="create"
          />

          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        <img src={profileImage} alt="User Image" />
                      </div>
                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="profile-info-left">
                            <h3 className="user-name m-t-0 mb-0 capitalize-each-word">
                              {localStorage.getItem("demo_user_name") ||
                                [
                                  pipDetails?.first_name,
                                  pipDetails?.middle_name,
                                  pipDetails?.last_name,
                                ]
                                  .filter(Boolean)
                                  .join(" ")}
                            </h3>
                            <div className="staff-id">
                              Employee ID: {pipDetails?.employment_id || "N/A"}
                            </div>
                            <h6 className="text-muted">
                              {pipDetails?.department_name}
                            </h6>
                            <small className="text-muted">
                              {pipDetails?.designation_name}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <ul className="personal-info">
                            <li>
                              <div className="title">Status:</div>
                              <div className="badge bg-danger">
                                {pipDetails?.pip_status == 1
                                  ? "On PIP"
                                  : "Close"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Start Date:</div>
                              <div className="text">
                                {pipDetails?.start_date}
                              </div>
                            </li>
                            <li>
                              <div className="title">End Date:</div>
                              <div className="text">{pipDetails?.end_date}</div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <span>PIP Reason :</span>{" "}
                        <span className="text-secondary">
                          {pipDetails?.pip_reason}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {reviewCycles.length > 0 && <h4 className="mt-4">Review Cycles</h4>}
          {reviewCycles?.length > 0 ? (
            reviewCycles?.map((cycle, index) => {
              const activeDate = new Date(cycle.review_cycle_start_date);
              const isActive = activeDate <= today;

              // Hide cycle if not active yet
              if (!isActive) return null;

              return (
                <div className="card mt-3" key={cycle.id}>
                  <div className="card-header d-flex align-item-center justify-content-between">
                    <div>
                      <strong>Review Cycle {index + 1}</strong> (
                      <span className="text-secondary">
                        {cycle.review_cycle_start_date})
                      </span>
                    </div>
                    {!cycle.editMode &&
                      cycle.feedbacks?.length > 0 &&
                      reviewCycles?.length != cycle?.cycle && (
                        <div className="text-end">
                          <button
                            className="m-0 p-0 border-0 bg-white"
                            onClick={() => handleReEdit(cycle.id)}
                          >
                            <i className="fa-solid fa-pen-to-square cursor-pointer text-primary"></i>
                          </button>
                        </div>
                      )}
                  </div>
                  <div className="card-body pt-0">
                    {/* Employee's Performance and Comment */}
                    <div className="row">
                      <div className="col-md-12 col-12">
                        <p>
                          <span>Employee Comment : </span>
                          <span className="text-secondary">
                            {cycle?.comment || "-"}
                          </span>
                        </p>
                      </div>
                      <div className="col-md-12 col-12">
                        <p>
                          <span>Commented On : </span>
                          <span className="text-secondary">
                            {cycle?.reviewd_date || "-"}
                          </span>
                        </p>
                      </div>
                    </div>

                    { cycle?.reviewd_date  && (cycle.editMode ? (
                      <>
                        <div className="mt-3">
                          <h6>
                            {cycle.feedbacks?.length > 0
                              ? "Edit Feedback"
                              : "Add Feedback"}
                          </h6>
                          <div className="mb-2">
                            <label>Reviewer Comment</label>
                            <textarea
                              className="form-control"
                              rows={3}
                              value={cycle.reviewer_comment || ""}
                              onChange={(e) =>
                                handleChange(
                                  cycle.id,
                                  "reviewer_comment",
                                  e.target.value
                                )
                              }
                            />
                            {errors[cycle.id]?.reviewer_comment && (
                              <div className="text-danger">
                                {errors[cycle.id].reviewer_comment}
                              </div>
                            )}
                          </div>
                          <div className="mb-2">
                            <label>Review Status</label>
                            <select
                              className="form-control"
                              value={cycle.review_status || ""}
                              onChange={(e) =>
                                handleChange(
                                  cycle.id,
                                  "review_status",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select Status</option>
                              <option value="Approved">Approved</option>
                              <option value="Reject">Rejected</option>
                            </select>
                            {errors[cycle.id]?.review_status && (
                              <div className="text-danger">
                                {errors[cycle.id].review_status}
                              </div>
                            )}
                          </div>
                          <div className="text-end">
                            <button
                              className="btn btn-success"
                              onClick={() => handleSaveFeedback(cycle.id)}
                            >
                              {cycle.feedbacks?.length > 0
                                ? "Update Feedback"
                                : "Save Feedback"}
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="mt-3">
                          <h5 className="mb-2">Reviewer Feedbacks</h5>
                          {cycle.feedbacks?.length > 0 ? (
                            cycle.feedbacks.map((feedback, fIndex) => (
                              <div key={fIndex} className="card mb-2">
                                <div className="card-body p-2">
                                  <div className="row">
                                    <div className="col-md-6 col-12">
                                      <p>
                                        <strong>Reviewer : </strong>
                                        <span className="text-secondary">
                                          {feedback.reviewer_first_name}{" "}
                                          {feedback?.reviewer_middle_name || ""}{" "}
                                          {feedback?.reviewer_last_name}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="col-md-6 col-12">
                                      <p>
                                        <strong>Status : </strong>
                                        <span
                                          className={`badge ${
                                            feedback.review_status ===
                                            "Approved"
                                              ? "bg-success"
                                              : "bg-danger"
                                          }`}
                                        >
                                          {feedback.review_status}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-12 col-12">
                                      <p>
                                        <strong>Comment : </strong>
                                        <div className="text-secondary">
                                          {feedback.reviewer_comment}
                                        </div>
                                      </p>
                                    </div>
                                  </div>
                                  {feedback.review_created_at && (
                                    <p>
                                      <strong>Reviewed On : </strong>
                                      <span className="text-secondary">
                                        {feedback.review_created_at &&
                                          formatDateInTimezone(
                                            feedback.review_created_at
                                          )}
                                      </span>
                                    </p>
                                  )}
                                </div>
                              </div>
                            ))
                          ) : (
                            <p className="text-secondary">
                              No feedback provided yet.
                            </p>
                          )}
                        </div>
                      </>
                    ))}
                  </div>
                </div>
              );
            })
          ) : (
            <p>No review cycles available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PIPDetails;
